import { render } from "./PageCallAction.vue?vue&type=template&id=d98dc3f6"
import script from "./PageCallAction.vue?vue&type=script&lang=js"
export * from "./PageCallAction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__